import { createAction, createReducer } from "@reduxjs/toolkit";

export const addInput = createAction('addInput')
export const removeInput = createAction('removeInput')
export const resetInput = createAction('resetInput')


const initialState = {
    cellInputs: [],
};

export const newRow = createReducer(initialState, {
    [addInput]: (state, action) => {
        return{
            cellInputs: [...state.cellInputs, action.payload]
        }
    },
    [removeInput]: (state, action) => {
        return {
            cellInputs: state.cellInputs.filter(x => x !== action.payload)
        }
    },
    [resetInput]: () => {
        return {
            cellInputs: []
        } 
    },
}
);